export default {
  title: 'Tilauksen ulkoasu',
  form: {
    show_hero_image_with_offers: {
      label: 'Näytä hero-kuva tarjousten kanssa',
      description: 'Oletuksena tarjouskuvan lisääminen piilottaa hero-kuvan. Ota tämä käyttöön näyttääksesi molemmat.',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
  },
};
